export default {
  state: {
    serviceCategories: [],
    loading: false,
  },
  getters: {
    serviceCategories: state => state.serviceCategories,
    loading: state => state.loading,
  },
  mutations: {
    setServiceCategories(state, serviceCategories) {
      state.serviceCategories = serviceCategories;
    },
    setLoading(state, display) {
      state.loading = display;
    }
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const serviceCategories = await axios.get('api/service-categories');
        commit('setServiceCategories', serviceCategories);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/service-categories/' + id);
      } catch (e) {
      }
    },

    async create({ commit }, payLoad) {
      try {
        await axios.post('api/service-categories', payLoad);
      } catch (e) {
      }
    },

    async update({ commit }, payLoad) {
      try {
        await axios.put('api/service-categories', payLoad);
      } catch (e) {
      }
    },

    async delete({}, id) {
      await axios.delete('api/service-categories/' + id);
    }
  },
};
